/**
 * 화이트보드 상수 정의
 * v1 원본: utils/whiteboard/index.js (상단 상수부)
 */

/** 화이트보드 가짜 참여자 ID (participantsSlice에 삽입) */
export const WHITEBOARD_ID = 'whiteboard';

/** 메타데이터 키 */
export const METADATA_KEYS = {
  WHITEBOARD_ID: 'whiteboard',
  WHITEBOARD_OWNER: 'whiteboard_owner',
  FILE_METADATA: 'whiteboard_files',
} as const;

/**
 * 협업 서버 URL — 환경변수에 따라 분기
 * v1: REACT_APP_TYPE === 'wehago' ? video.wehago.com : rtctest.wehago.com
 */
export function getCollabServerUrl(): string {
  const appType = (import.meta.env.VITE_APP_TYPE as string | undefined) ?? 'dev';
  if (appType === 'wehago' || appType === 'wehagov') {
    return 'https://video.wehago.com';
  }
  return 'https://rtctest.wehago.com';
}

export const COLLAB_SERVER_URL = getCollabServerUrl();

/** 배경색 프리셋 (SketchModeTitle에서 사용) */
export const BG_COLORS = [
  { label: '흰색', value: '#ffffff' },
  { label: '회색', value: '#f0f2f7' },
  { label: '파란색', value: '#aed2ff' },
  { label: '노란색', value: '#ffefc8' },
] as const;

/** 격자 프리셋 */
export const GRID_PRESETS = [
  { label: '없음', gridModeEnabled: false, gridSize: 0 },
  { label: '격자 1', gridModeEnabled: true, gridSize: 20 },
  { label: '격자 2', gridModeEnabled: true, gridSize: 40 },
] as const;

/** 문서공유 모드 기본 배경 설정 */
export const DOC_SHARE_BACKGROUND = {
  viewBackgroundColor: '#f1f3f5',
  gridModeEnabled: true,
  gridSize: 40,
} as const;
